import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { map } from "rxjs/operators";
import {FlujoVentaPasosIntegracionVinculacion} from "../_models/flujo-venta-paso-integracion-vinculacion";
import {Politica} from "../_models/politica";
import {PoliticaConfigurada} from "../_models/politica-configurada";

@Injectable({
  providedIn: 'root'
})
export class PoliticasConfiguradasService {

  private rutServicioCanal = AppSettings.rutServiciosAPL + "/api/flujoVentaPasosPoliticas"

  constructor(
    private httpClient: HttpClient,
  ) {}

  listadoPoliticasPasoEnabled( codigoPaso: string ) {
    return this.httpClient
      .get(`${this.rutServicioCanal}/flujoVentaPasos/code/${codigoPaso}/enabled`)
      .pipe(map((res) => res as any[]));
  }

  list() {
    return this.httpClient
      .get(this.rutServicioCanal)
      .pipe(map((res) => res as PoliticaConfigurada[]));
  }

  listEnabled() {
    return this.httpClient
      .get(this.rutServicioCanal + "/enabled")
      .pipe(map((res) => res as PoliticaConfigurada[]));
  }

  bulk( politicas: PoliticaConfigurada[] ) {
    return this.httpClient
      .post(this.rutServicioCanal + "/bulk", politicas)
      .pipe(map((res) => res as Politica[]));
  }

  post( politica: PoliticaConfigurada[] ) {
    return this.httpClient
      .post(this.rutServicioCanal, politica)
      .pipe(map((res) => res as Politica[]));
  }

  put( politica: PoliticaConfigurada ) {
    return this.httpClient
      .post(this.rutServicioCanal, politica)
      .pipe(map((res) => res as Politica[]));
  }
}
